// ChartExportButton.js
// "Export as image" for any chart. `onExport` returns the promise of the
// download; while it runs the button shows a spinner and refuses a second
// click, and when it rejects the button turns red and says so on hover — the
// button itself is the retry. The failure is shown ON the button rather than
// beside it because the result tab strip overlays its settings gear just to
// the left, where a caption would land.
import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';

function ChartExportButton({ onExport, disabled = false }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  const run = async () => {
    setBusy(true);
    setFailed(false);
    try {
      await onExport();
    } catch (err) {
      console.error('Chart export failed:', err);
      setFailed(true);
    } finally {
      setBusy(false);
    }
  };

  const tone = failed ? '#E57373' : 'rgba(255, 255, 255, 0.7)';
  const edge = failed ? '#E57373' : 'rgba(255, 255, 255, 0.3)';
  return (
    <Tooltip title={failed ? 'Export failed — click to try again' : 'Export as image'}>
      <span>
        <IconButton
          onClick={run}
          disabled={busy || disabled}
          size="medium"
          aria-label={failed ? 'Export failed — click to try again' : 'Export as image'}
          sx={{
            color: tone,
            border: `1px solid ${edge}`,
            backgroundColor: failed ? 'rgba(229, 115, 115, 0.08)' : 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            padding: '8px',
            transition: 'all 0.2s ease',
            '&:hover': {
              color: '#4E85EB',
              border: '1px solid #4E85EB',
              backgroundColor: 'rgba(78, 133, 235, 0.1)',
            },
          }}
        >
          {busy ? <CircularProgress size={24} color="inherit" /> : failed ? <ErrorOutlineIcon /> : <DownloadIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}

export default ChartExportButton;
